import {Button} from '@components/ui/button'
import {useTranslation, TKey} from '@/translations/i18n.tsx'
import {useState} from 'react'
import {ScheduleModal} from '@features/assignment/components/schedule-modal'
import {Assignment, ServiceType} from '@features/assignment/types.ts'
import {formatLocaleDate} from '@/dates.ts'
import {
    ASSIGNMENT_DESCRIPTION_PARAGRAPH_CLASSNAME,
    ASSIGNMENT_DESCRIPTION_TEXT_CLASSNAME,
    ASSIGNMENT_DESCRIPTION_TITLE_CLASSNAME,
    ASSIGNMENT_DESCRIPTION_WRAPPER_CLASSNAME
} from '@features/assignment/constants'

export const AcceptedFreelancerNotReadyDescription = ({
    assignment,
    serviceType
}: {
    assignment: Assignment
    serviceType: ServiceType
}) => {
    const {t} = useTranslation()
    const [isScheduleModalOpen, setIsScheduleModalOpen] = useState(false)

    return (
        <div className={ASSIGNMENT_DESCRIPTION_WRAPPER_CLASSNAME}>
            <div className={ASSIGNMENT_DESCRIPTION_TEXT_CLASSNAME}>
                <h3 className={ASSIGNMENT_DESCRIPTION_TITLE_CLASSNAME}>
                    {t('assignment:descriptions:accepted_freelancer_not_ready:title', {
                        date: assignment.photographer_not_available_at
                            ? formatLocaleDate(assignment.photographer_not_available_at, 'PPP')
                            : '-'
                    })}
                </h3>
                <p className={ASSIGNMENT_DESCRIPTION_PARAGRAPH_CLASSNAME}>
                    {assignment.photographer_available_at
                        ? t(
                              `assignment:descriptions:accepted_freelancer_not_ready:paragraph_date:${serviceType}` as TKey,
                              {
                                  date: formatLocaleDate(assignment.photographer_available_at, 'PPP')
                              }
                          )
                        : t(`assignment:descriptions:accepted_freelancer_not_ready:paragraph:${serviceType}` as TKey)}
                </p>
            </div>
            <Button onClick={() => setIsScheduleModalOpen(true)}>{t('assignment:descriptions:schedule')}</Button>
            {isScheduleModalOpen && (
                <ScheduleModal
                    assignment={assignment}
                    serviceType={serviceType}
                    onClose={() => setIsScheduleModalOpen(false)}
                />
            )}
        </div>
    )
}
